<template>
  <div>
    <div v-if="step == 0">
      <SelectMedicineID
        :showMedicine="false"
        :rest_home_id="rest_home_id"
        v-on:selected="selected"
      />
      <ErrorsMessages :errors="errors" />
    </div>
    <div v-if="step == 1">
      <div class="row">
        <div class="col-md-12">
          <label>NOME COMERCIAL</label>
          <input
            :disabled="medicine"
            v-model="name"
            type="text"
            class="form-control"
          />
        </div>
        <div class="col-md-12">
          <SelectActiveIngredientID
            :disabled="medicine ? true : false"
            refautofocus
            v-model="active_ingredient_id"
          />
        </div>
        <div class="col-md-6">
          <label>UNIDADE DE MEDIDA</label>
          <select
            @change="handleChangeUnitOfMeasurementId($event.target.value)"
            :disabled="medicine"
            v-model="unit_of_measurement_id"
            class="form-control"
          >
            <option value="">SELECIONE...</option>
            <option
              v-for="value in unitOfMeasurements"
              :key="value.id"
              :value="value.id"
              :ref="`unit_of_measurement_${value.id}`"
              :data-name="value.name"
              :data-v="value.value"
              :data-abbreviation="value.abbreviation"
            >
              {{ value.name }}
            </option>
          </select>
        </div>
        <div class="col-md-6">
          <label>UNIDADE DE ADMINISTRAÇÃO</label>
          <input
            disabled
            v-model="unit_of_measurement_abbreviation"
            type="text"
            class="form-control"
          />
        </div>
        <div class="col-md-6">
          <label>TIPO DE RECEITA</label>
          <select
            :disabled="medicine"
            v-model="type_of_recipe_id"
            class="form-control"
          >
            <option value="">SELECIONE...</option>
            <option
              v-for="value in typesOfRecipe"
              :key="value.id"
              :value="value.id"
            >
              {{ value.name }}
            </option>
          </select>
        </div>
        <div class="col-md-6">
          <label>VIA DE ADMINISTRAÇÃO</label>
          <select v-model="route_of_administration_id" class="form-control">
            <option value="">SELECIONE...</option>
            <option
              v-for="value in routeOfAdministration"
              :key="value.id"
              :value="value.id"
            >
              {{ value.name }}
            </option>
          </select>
        </div>
        <div class="col-md-12">
          <ErrorsMessages :errors="errors" />
        </div>
      </div>
    </div>
    <div v-if="step == 2">
      <div class="row">
        <div
          class="col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12 d-flex justify-content-center"
        >
          <i class="fas fa-capsules fa-3x color-blue"></i>
        </div>
        <div class="col-xl-10 col-lg-10 col-md-10 col-sm-12 col-12">
          <h6 class="mb-0">
            MEDICAMENTO:
            {{ name }}
          </h6>
          <h6 class="mb-0 text-two">
            UNIDADE DE MEDIDA:
            {{ unit_of_measurement_name }}
          </h6>
          <h6 class="mb-0 text-two">
            UNIDADE DE ADMINISTRAÇÃO:
            {{ unit_of_measurement_abbreviation }}
          </h6>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
          <label>FREQUÊNCIA</label>
          <select
            @change="handleChangeFrequency($event.target.value)"
            v-model="frequency"
            class="form-control"
          >
            <option value="DIARIO">DIÁRIO</option>
            <option value="SEMANAL">SEMANAL</option>
            <option
              v-if="group_prescription_medicine.type == 'LONGO_PRAZO'"
              value="MENSAL"
            >
              MENSAL
            </option>
            <option
              v-if="group_prescription_medicine.type == 'LONGO_PRAZO'"
              value="ANUAL"
            >
              ANUAL
            </option>
            <option
              v-if="group_prescription_medicine.type == 'NORMAL'"
              value="EVENTUAL"
            >
              EVENTUAL
            </option>
          </select>
        </div>
        <div
          v-show="show_all_frequency || show_quantity_of_times_a_day"
          class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12"
        >
          <label>QUANTIDADE DIÁRIA</label>
          <select
            @change="handleChangeMedicineAmountOfTimesId($event.target.value)"
            v-model="medicine_amount_of_times_id"
            class="form-control"
          >
            <option value="">SELECIONE...</option>
            <option
              v-for="value in amountOfTimes"
              :key="value.id"
              :value="value.id"
              :ref="`medicine_amount_of_times_${value.id}`"
              :data-type="value.type"
            >
              {{ value.name }}
            </option>
          </select>
        </div>
        <div
          v-if="show_all_frequency"
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex align-items-center"
        >
          <label class="mb-0 day-width">A CADA</label>
          <input v-model="every" type="text" class="form-control" />
          <label class="mb-0 day-width pl-3">
            {{ medicine_frequency_abbreviation }}(S)
          </label>
        </div>
        <div v-if="show_weekly" class="p-2">
          <v-btn
            :class="['v-no-border-radius', DOM ? 'v-primary' : '']"
            @click="DOM = !DOM"
          >
            DOM
          </v-btn>
          <v-btn
            :class="['v-no-border-radius', SEG ? 'v-primary' : '']"
            @click="SEG = !SEG"
          >
            SEG
          </v-btn>
          <v-btn
            :class="['v-no-border-radius', TER ? 'v-primary' : '']"
            @click="TER = !TER"
          >
            TER
          </v-btn>
          <v-btn
            :class="['v-no-border-radius', QUA ? 'v-primary' : '']"
            @click="QUA = !QUA"
          >
            QUA
          </v-btn>
          <v-btn
            :class="['v-no-border-radius', QUI ? 'v-primary' : '']"
            @click="QUI = !QUI"
          >
            QUI
          </v-btn>
          <v-btn
            :class="['v-no-border-radius', SEX ? 'v-primary' : '']"
            @click="SEX = !SEX"
          >
            SEX
          </v-btn>
          <v-btn
            :class="['v-no-border-radius', SAB ? 'v-primary' : '']"
            @click="SAB = !SAB"
          >
            SAB
          </v-btn>
        </div>
        <div
          v-if="show_shifts"
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
        >
          <div class="row">
            <div
              class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 d-flex justify-content-center align-items-center"
            >
              <vs-checkbox v-model="dawn">MADRUGADA</vs-checkbox>
            </div>
            <div
              v-if="
                unit_of_measurement_value == 'ML' ||
                unit_of_measurement_value == 'UI'
              "
              class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"
            >
              <label>UI/ML/GOTAS</label>
              <select v-model="ml_or_drops_dawn_quantity" class="form-control">
                <option value="UI">UI</option>
                <option value="ML">ML</option>
                <option value="GOTAS">GOTAS</option>
              </select>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
              <label
                >{{ unit_of_measurement_name
                }}{{
                  unit_of_measurement_name == "ML" ||
                  unit_of_measurement_name == "UI/ML"
                    ? "/GOTAS"
                    : ""
                }}</label
              >
              <input v-model="dawn_quantity" type="text" class="form-control" />
            </div>
          </div>
          <hr />
          <div class="row">
            <div
              class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 d-flex justify-content-center align-items-center"
            >
              <vs-checkbox v-model="morning">MANHÃ</vs-checkbox>
            </div>
            <div
              v-if="
                unit_of_measurement_value == 'ML' ||
                unit_of_measurement_value == 'UI'
              "
              class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"
            >
              <label>UI/ML/GOTAS</label>
              <select
                v-model="ml_or_drops_morning_quantity"
                class="form-control"
              >
                <option value="UI">UI</option>
                <option value="ML">ML</option>
                <option value="GOTAS">GOTAS</option>
              </select>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
              <label
                >{{ unit_of_measurement_name }}
                {{
                  unit_of_measurement_name == "ML" ||
                  unit_of_measurement_name == "UI/ML"
                    ? "/GOTAS"
                    : ""
                }}
              </label>
              <input
                v-model="morning_quantity"
                type="text"
                class="form-control"
              />
            </div>
          </div>
          <hr />
          <div class="row">
            <div
              class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 d-flex justify-content-center align-items-center"
            >
              <vs-checkbox v-model="afternoon">TARDE</vs-checkbox>
            </div>
            <div
              v-if="
                unit_of_measurement_value == 'ML' ||
                unit_of_measurement_value == 'UI'
              "
              class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"
            >
              <label>UI/ML/GOTAS</label>
              <select
                v-model="ml_or_drops_afternoon_quantity"
                class="form-control"
              >
                <option value="UI">UI</option>
                <option value="ML">ML</option>
                <option value="GOTAS">GOTAS</option>
              </select>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
              <label
                >{{ unit_of_measurement_name
                }}{{
                  unit_of_measurement_name == "ML" ||
                  unit_of_measurement_name == "UI/ML"
                    ? "/GOTAS"
                    : ""
                }}</label
              >
              <input
                v-model="afternoon_quantity"
                type="text"
                class="form-control"
              />
            </div>
          </div>
          <hr />
          <div class="row">
            <div
              class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 d-flex justify-content-center align-items-center"
            >
              <vs-checkbox v-model="night">NOITE</vs-checkbox>
            </div>
            <div
              v-if="
                unit_of_measurement_value == 'ML' ||
                unit_of_measurement_value == 'UI'
              "
              class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"
            >
              <label>UI/ML/GOTAS</label>
              <select v-model="ml_or_drops_night_quantity" class="form-control">
                <option value="UI">UI</option>
                <option value="ML">ML</option>
                <option value="GOTAS">GOTAS</option>
              </select>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
              <label
                >{{ unit_of_measurement_name
                }}{{
                  unit_of_measurement_name == "ML" ||
                  unit_of_measurement_name == "UI/ML"
                    ? "/GOTAS"
                    : ""
                }}</label
              >
              <input
                v-model="night_quantity"
                type="text"
                class="form-control"
              />
            </div>
          </div>
          <hr />
          <!-- shift_5 -->
          <div class="row">
            <div
              class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 d-flex justify-content-center align-items-center"
            >
              <vs-checkbox v-model="shift_5">5º</vs-checkbox>
            </div>
            <div
              v-if="
                unit_of_measurement_value == 'ML' ||
                unit_of_measurement_value == 'UI'
              "
              class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"
            >
              <label>UI/ML/GOTAS</label>
              <select
                v-model="ml_or_drops_shift_5_quantity"
                class="form-control"
              >
                <option value="UI">UI</option>
                <option value="ML">ML</option>
                <option value="GOTAS">GOTAS</option>
              </select>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
              <label
                >{{ unit_of_measurement_name
                }}{{
                  unit_of_measurement_name == "ML" ||
                  unit_of_measurement_name == "UI/ML"
                    ? "/GOTAS"
                    : ""
                }}</label
              >
              <input
                v-model="shift_5_quantity"
                type="text"
                class="form-control"
              />
            </div>
          </div>
          <hr />
          <!-- shift_6 -->
          <div class="row">
            <div
              class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 d-flex justify-content-center align-items-center"
            >
              <vs-checkbox v-model="shift_6">6º</vs-checkbox>
            </div>
            <div
              v-if="
                unit_of_measurement_value == 'ML' ||
                unit_of_measurement_value == 'UI'
              "
              class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"
            >
              <label>UI/ML/GOTAS</label>
              <select
                v-model="ml_or_drops_shift_6_quantity"
                class="form-control"
              >
                <option value="UI">UI</option>
                <option value="ML">ML</option>
                <option value="GOTAS">GOTAS</option>
              </select>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
              <label
                >{{ unit_of_measurement_name
                }}{{
                  unit_of_measurement_name == "ML" ||
                  unit_of_measurement_name == "UI/ML"
                    ? "/GOTAS"
                    : ""
                }}</label
              >
              <input
                v-model="shift_6_quantity"
                type="text"
                class="form-control"
              />
            </div>
          </div>
          <hr />
          <!-- shift_7 -->
          <div class="row">
            <div
              class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 d-flex justify-content-center align-items-center"
            >
              <vs-checkbox v-model="shift_7">7º</vs-checkbox>
            </div>
            <div
              v-if="
                unit_of_measurement_value == 'ML' ||
                unit_of_measurement_value == 'UI'
              "
              class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"
            >
              <label>UI/ML/GOTAS</label>
              <select
                v-model="ml_or_drops_shift_7_quantity"
                class="form-control"
              >
                <option value="UI">UI</option>
                <option value="ML">ML</option>
                <option value="GOTAS">GOTAS</option>
              </select>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
              <label
                >{{ unit_of_measurement_name
                }}{{
                  unit_of_measurement_name == "ML" ||
                  unit_of_measurement_name == "UI/ML"
                    ? "/GOTAS"
                    : ""
                }}</label
              >
              <input
                v-model="shift_7_quantity"
                type="text"
                class="form-control"
              />
            </div>
          </div>
          <hr />
          <!-- shift_8 -->
          <div class="row">
            <div
              class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 d-flex justify-content-center align-items-center"
            >
              <vs-checkbox v-model="shift_8">8º</vs-checkbox>
            </div>
            <div
              v-if="
                unit_of_measurement_value == 'ML' ||
                unit_of_measurement_value == 'UI'
              "
              class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"
            >
              <label>UI/ML/GOTAS</label>
              <select
                v-model="ml_or_drops_shift_8_quantity"
                class="form-control"
              >
                <option value="UI">UI</option>
                <option value="ML">ML</option>
                <option value="GOTAS">GOTAS</option>
              </select>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
              <label
                >{{ unit_of_measurement_name
                }}{{
                  unit_of_measurement_name == "ML" ||
                  unit_of_measurement_name == "UI/ML"
                    ? "/GOTAS"
                    : ""
                }}</label
              >
              <input
                v-model="shift_8_quantity"
                type="text"
                class="form-control"
              />
            </div>
          </div>
        </div>
        <div
          v-if="
            show_quantity &&
            (unit_of_measurement_value == 'ML' ||
              unit_of_measurement_value == 'UI')
          "
          class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12"
        >
          <label>UI/ML/GOTAS</label>
          <select v-model="ml_or_drops" class="form-control">
            <option value="UI">UI</option>
            <option value="ML">ML</option>
            <option value="GOTAS">GOTAS</option>
          </select>
        </div>
        <div
          v-if="show_quantity"
          :class="[
            unit_of_measurement_value == 'ML' ||
            unit_of_measurement_value == 'UI'
              ? 'col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12'
              : 'col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12',
          ]"
        >
          <label
            >{{ unit_of_measurement_name
            }}{{
              unit_of_measurement_name == "ML" ||
              unit_of_measurement_name == "UI/ML"
                ? "/GOTAS"
                : ""
            }}</label
          >
          <input v-model="quantity" type="text" class="form-control" />
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0">
          <InfUnitOfMeasurement
            :unit_of_measurement_value="unit_of_measurement_value"
          />
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <ErrorsMessages :errors="errors" />
        </div>
      </div>
    </div>
    <div v-if="step == 2.5">
      <div class="row">
        <div
          class="col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12 d-flex justify-content-center"
        >
          <i class="fas fa-capsules fa-3x color-blue"></i>
        </div>
        <div class="col-xl-10 col-lg-10 col-md-10 col-sm-12 col-12">
          <h6 class="mb-0">
            MEDICAMENTO:
            {{ name }}
          </h6>
          <h6 class="mb-0 text-two">
            UNIDADE DE MEDIDA:
            {{ unit_of_measurement_name }}
          </h6>
          <h6 class="mb-0 text-two">
            UNIDADE DE ADMINISTRAÇÃO:
            {{ unit_of_measurement_abbreviation }}
          </h6>
        </div>
        <div class="col-md-8 pt-0 pb-0">
          <label>REPETIR DOSAGEM</label>
          <div class="row">
            <div class="col-md-10">
              <vs-slider :min="0" :max="30" v-model="repeat_dosage" />
            </div>
            <div class="col-md-2">
              <div class="d-flex justify-content-center align-items-center">
                <h3 class="c-primary mr-1">{{ repeat_dosage }}</h3>
                {{ repeat_dosage == 0 || repeat_dosage == 1 ? "DIA" : "DIAS" }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 pt-0 pb-0">
          <label>QUANTAS VEZES</label>
          <select v-model="how_many_times" class="form-control">
            <option v-for="repeat of 3" :key="repeat" :value="repeat">
              {{ repeat }}
              {{ repeat == 1 ? "VEZ" : "VEZES" }}
            </option>
          </select>
        </div>
        <div class="col-md-4 pt-0 pb-0">
          <label>TIPO DE REPETIÇÃO</label>
          <select
            v-model="repeat_type"
            @change="handleChangeRepeatType"
            class="form-control"
          >
            <option value="SEMANA">SEMANAL</option>
            <!-- <option value="DIA">DIÁRIA</option> -->
          </select>
        </div>
        <div class="col-md-4 pt-0 pb-0" v-if="repeat_type == 'SEMANA'">
          <label>REPETIR APÓS</label>
          <select v-model="repeat_after" class="form-control">
            <option value="NAO">NÃO REPETIR</option>
            <option v-for="repeat of 3" :key="repeat" :value="repeat">
              {{ repeat }}
              {{ repeat == 1 ? "SEMANA" : `${repeat_after_type}S` }}
            </option>
          </select>
        </div>
        <div class="col-md-4 pt-0 pb-0" v-if="repeat_type == 'DIA'">
          <label>REPETIR APÓS</label>
          <!-- 16 - 29 dias -->
          <select v-model="repeat_after" class="form-control">
            <option value="NAO">NÃO REPETIR</option>
            <option
              v-show="repeat >= 16 && repeat <= 29"
              v-for="repeat of 29"
              :key="repeat"
              :value="repeat"
            >
              {{ repeat }} DIAS
            </option>
          </select>
        </div>
      </div>
    </div>
    <div v-if="step == 3">
      <div class="row">
        <div class="col-md-12 pt-0 pb-0">
          <div class="row">
            <div
              class="col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12 pt-0 pb-0 d-flex justify-content-center"
            >
              <i class="fas fa-capsules fa-3x color-blue"></i>
            </div>
            <div class="col-xl-10 col-lg-10 col-md-10 col-sm-12 col-12 pt-1">
              <h6 class="mb-0 check-text-center">
                MEDICAMENTO:
                {{ name }}
              </h6>
              <h6 class="mb-0 text-fourteen check-text-center worksansr">
                UNIDADE DE MEDIDA:
                {{ unit_of_measurement_name }}
              </h6>
              <h6 class="mb-0 text-fourteen check-text-center worksansr">
                UNIDADE DE ADMINISTRAÇÃO:
                {{ unit_of_measurement_abbreviation }}
              </h6>
            </div>
          </div>
        </div>

        <div
          v-if="!show_instruction"
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0"
        >
          <h6 class="text-fourteen">DURAÇÃO</h6>
          <div class="d-flex">
            <vs-radio
              class="col-md-4 pt-0 pb-0"
              @change="handleChangeDuration($event.target.value)"
              v-model="duration"
              vs-value="CONTINUO"
              >CONTÍNUO</vs-radio
            >
            <vs-radio
              class="col-md-4 pt-0 pb-0"
              @change="handleChangeDuration($event.target.value)"
              v-if="show_during_a_period"
              v-model="duration"
              vs-value="DURANTE_UM_PERIODO"
              >DURANTE UM PERÍODO</vs-radio
            >
            <vs-radio
              class="col-md-4 pt-0 pb-0"
              @change="handleChangeDuration($event.target.value)"
              v-model="duration"
              vs-value="ATE_A_DATA"
              >ATÉ A DATA</vs-radio
            >
          </div>
        </div>
        <div
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pl-4 pr-4 pt-0 pb-0"
          v-if="
            (!show_instruction && show_start_date) ||
            (!show_instruction && show_end_date) ||
            (!show_instruction && show_duration_time)
          "
        >
          <div class="row v-clean">
            <div
              v-if="!show_instruction && show_start_date"
              class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 pt-1 pb-1"
            >
              <h6 class="text-fourteen">DATA DE INÍCIO</h6>
              <input v-model="start_date" type="date" class="form-control" />
            </div>
            <div
              v-if="!show_instruction && show_duration_time"
              class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 pt-1 pb-1"
            >
              <h6 class="text-fourteen">TEMPO DE DURAÇÃO</h6>
              <vs-slider :min="1" :max="30" v-model="duration_time" />
              <div class="d-flex justify-content-center align-items-center">
                <h3 class="c-primary mr-1">{{ duration_time }}</h3>
                dia(s)
              </div>
            </div>
            <div
              v-if="!show_instruction && show_end_date"
              class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 pt-1 pb-1"
            >
              <h6 class="text-fourteen">DATA DE TÉRMINO</h6>
              <input v-model="end_date" type="date" class="form-control" />
            </div>
          </div>
        </div>
        <div
          v-if="duration == 'CONTINUO'"
          class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mb-2 pt-0 pl-3 pt-0 pb-0"
        >
          <h6 class="text-fourteen">INICIAR MEDICAMENTO</h6>
          <input v-model="init" type="date" class="form-control" />
        </div>
        <div
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pl-3 pt-0 pb-0"
        >
          <h6 class="text-fourteen">INSTRUÇÃO</h6>
          <ChromeSpeechToTextTextarea
            rows="4"
            max-rows="10"
            v-model="instruction"
          />
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0">
          <ErrorsMessages :errors="errors" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
        <v-btn v-if="step == 0" @click="$emit('cancel')" class="btn-cancel">
          CANCELAR</v-btn
        >
        <v-btn v-show="step !== 0" @click="handlePrevStep" class="btn-return"
          ><i class="fas fa-arrow-left mr-2 text-twenty"></i> Voltar</v-btn
        >
      </div>
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 text-right">
        <v-btn
          v-show="step != 3"
          :disabled="loading"
          @click="handleNextStep"
          class="btn-save"
        >
          AVANÇAR
          <i class="ml-1 fas fa-arrow-right text-twenty"></i>
        </v-btn>

        <v-btn
          v-show="step == 3"
          :disabled="loading"
          @click="handleNextStep"
          :class="[
            group_prescription_medicine.status == 'PENDENTE'
              ? 'btn-save'
              : 'btn-notcertified',
          ]"
        >
          <span v-show="loading">CARREGANDO</span>
          <span
            :class="[
              group_prescription_medicine.status == 'PENDENTE' &&
                !loading &&
                'd-flex align-items-center',
            ]"
            v-show="
              group_prescription_medicine.status == 'PENDENTE' && !loading
            "
            ><i class="fas fa-check mr-2 text-twenty"></i> ADICIONAR</span
          >
          <span
            :class="[
              group_prescription_medicine.status == 'FINALIZADO' &&
                !loading &&
                'd-flex align-items-center',
            ]"
            v-show="
              group_prescription_medicine.status == 'FINALIZADO' && !loading
            "
            ><i class="fas fa-check mr-2 text-twenty"></i>
            FINALIZAR MANUAL COM ASSINATURA ELETRÔNICA
          </span>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import SelectMedicineID from "../../../templates/Components/SelectMedicineID";

import SelectActiveIngredientID from "../../../templates/Components/SelectActiveIngredientID";

import InfUnitOfMeasurement from "../../../templates/Components/InfUnitOfMeasurement";

import ErrorsMessages from "../../../templates/Components/ErrorsMessages";

import ChromeSpeechToTextTextarea from "../../../templates/Components/ChromeSpeechToTextTextarea";

import api from "../../../services/api";

import { userData } from "../../../lib/functions";

import toast from "../../../lib/ToastNotification";

import { isValidAmount } from "../../../lib/amount";

import { formatDateToUs, numbersOnly } from "../../../lib/format";

export default {
  name: "Medicine",
  components: {
    SelectMedicineID,
    SelectActiveIngredientID,
    InfUnitOfMeasurement,
    ErrorsMessages,
    ChromeSpeechToTextTextarea,
  },
  props: {
    group_prescription_medicine: Object,
  },
  data() {
    return {
      step: 0,
      medicine: false,
      medicine_type: null,
      user_id: "",
      rest_home_id: "",
      unit_of_measurement_id: "",
      route_of_administration_id: "",
      name: "",
      active_ingredient_id: "",
      active_ingredient: [],
      unit_of_measurement_name: "",
      unit_of_measurement_value: "",
      unit_of_measurement_abbreviation: "",
      medicine_amount_of_times_id: "",
      type_of_recipe_id: "",
      typesOfRecipe: [],
      unitOfMeasurements: [],
      routeOfAdministration: [],
      medicineAmountOfTimes: [],
      amountOfTimes: [],
      medicine_frequency_abbreviation: "DIA",
      errors: [],
      loading: false,
      show_all_frequency: true,
      show_weekly: false,
      type_medicine_amount_of_times_id: "DAY",
      show_shifts: false,
      frequency: "DIARIO",
      every: 1,
      morning: false,
      morning_quantity: "",
      afternoon: false,
      afternoon_quantity: "",
      night: false,
      night_quantity: "",
      shift_5: false,
      shift_5_quantity: "",
      shift_6: false,
      shift_6_quantity: "",
      shift_7: false,
      shift_7_quantity: "",
      shift_8: false,
      shift_8_quantity: "",
      dawn: false,
      dawn_quantity: "",
      DOM: false,
      SEG: false,
      TER: false,
      QUA: false,
      QUI: false,
      SEX: false,
      SAB: false,
      quantity: "",
      show_quantity: true,
      duration: "CONTINUO",
      show_during_a_period: false,
      instruction: "",
      show_instruction: false,
      start_date: "",
      show_start_date: false,
      end_date: "",
      show_end_date: false,
      duration_time: 1,
      show_duration_time: false,
      show_quantity_of_times_a_day: false,
      ml_or_drops: null,
      ml_or_drops_morning_quantity: null,
      ml_or_drops_afternoon_quantity: null,
      ml_or_drops_night_quantity: null,
      ml_or_drops_shift_5_quantity: null,
      ml_or_drops_shift_6_quantity: null,
      ml_or_drops_shift_7_quantity: null,
      ml_or_drops_shift_8_quantity: null,
      ml_or_drops_dawn_quantity: null,
      repeat_after_type: "SEMANA",
      repeat_dosage: 0,
      repeat_after: "NAO",
      how_many_times: 1,
      init: "",
      repeat_type: "SEMANA",
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    formatDateToUs,
    isValidAmount,
    numbersOnly,
    handleChangeRepeatType() {
      this.repeat_after = "NAO";
    },
    handlePrevStep() {
      const { step, group_prescription_medicine, frequency } = this;

      let SEMANAL = "SEMANAL";

      this.errors = [];

      if (step == 0) {
        return;
      }

      if (group_prescription_medicine.type == "NORMAL") {
        this.step = step - 1;
      } else {
        if (step == 3) {
          if (frequency == SEMANAL) {
            this.step = step - 1;
          } else {
            this.step = 2.5;
          }
        } else if (step == 2.5) {
          this.step = 2;
        } else {
          this.step = step - 1;
        }
      }
      // this.step = step - 1;
    },
    handleNextStep() {
      this.errors = [];

      let { step, group_prescription_medicine } = this;

      if (step == 0) {
        this.step = step + 1;
      }

      if (step == 1) {
        let {
          name,
          active_ingredient_id,
          unit_of_measurement_id,
          route_of_administration_id,
        } = this;

        if (!String(name).trim()) {
          this.errors.push({
            id: this.errors.length,
            message: "Informe o nome comercial",
          });
        }

        if (!active_ingredient_id) {
          this.errors.push({
            id: this.errors.length,
            message: "Informe o princípio ativo",
          });
        }

        if (!String(unit_of_measurement_id).trim()) {
          this.errors.push({
            id: this.errors.length,
            message: "Informe a unidade de medida",
          });
        }

        if (!String(route_of_administration_id).trim()) {
          this.errors.push({
            id: this.errors.length,
            message: "Informe via de admnistração",
          });
        }

        if (this.errors.length > 0) {
          return;
        }

        this.step = step + 1;
      }

      if (step == 2) {
        let {
          frequency,
          medicine_amount_of_times_id,
          medicine_frequency_abbreviation,
          every,
          DOM,
          SEG,
          TER,
          QUA,
          QUI,
          SEX,
          SAB,
          morning,
          morning_quantity,
          afternoon,
          afternoon_quantity,
          night,
          night_quantity,
          shift_5,
          shift_5_quantity,
          shift_6,
          shift_6_quantity,
          shift_7,
          shift_7_quantity,
          shift_8,
          shift_8_quantity,
          dawn,
          dawn_quantity,
          quantity,
          type_medicine_amount_of_times_id,
          unit_of_measurement_value,
        } = this;

        let DIARIO = "DIARIO";
        let SEMANAL = "SEMANAL";
        // let MENSAL = "MENSAL";
        // let ANUAL = "ANUAL";
        let EVENTUAL = "EVENTUAL";

        if (!String(frequency).trim()) {
          this.errors.push({
            id: this.errors.length,
            message: "Informe frequência",
          });
        }

        if (!String(medicine_amount_of_times_id).trim()) {
          this.errors.push({
            id: this.errors.length,
            message: "Informe quantidade diária",
          });
        }

        if (frequency != EVENTUAL) {
          if (frequency == SEMANAL) {
            if (!DOM && !SEG && !TER && !QUA && !QUI && !SEX && !SAB) {
              this.errors.push({
                id: this.errors.length,
                message: "Informe ao menos um dia da semana",
              });
            }
          }

          if (type_medicine_amount_of_times_id == "SHIFTS") {
            if (
              !morning &&
              !afternoon &&
              !night &&
              !dawn &&
              !shift_5 &&
              !shift_6 &&
              !shift_7 &&
              !shift_8
            ) {
              this.errors.push({
                id: this.errors.length,
                message: "Informe ao menos um turno",
              });
            }

            if (morning) {
              let verifyAmount = isValidAmount(
                morning_quantity,
                unit_of_measurement_value
              );

              if (verifyAmount.error) {
                this.errors.push({
                  id: this.errors.length,
                  message: verifyAmount.message,
                });
              }

              morning_quantity = verifyAmount.quantity;
            }

            if (afternoon) {
              let verifyAmount = isValidAmount(
                afternoon_quantity,
                unit_of_measurement_value
              );

              if (verifyAmount.error) {
                this.errors.push({
                  id: this.errors.length,
                  message: verifyAmount.message,
                });
              }

              afternoon_quantity = verifyAmount.quantity;
            }

            if (night) {
              let verifyAmount = isValidAmount(
                night_quantity,
                unit_of_measurement_value
              );

              if (verifyAmount.error) {
                this.errors.push({
                  id: this.errors.length,
                  message: verifyAmount.message,
                });
              }

              night_quantity = verifyAmount.quantity;
            }

            if (dawn) {
              let verifyAmount = isValidAmount(
                dawn_quantity,
                unit_of_measurement_value
              );

              if (verifyAmount.error) {
                this.errors.push({
                  id: this.errors.length,
                  message: verifyAmount.message,
                });
              }

              dawn_quantity = verifyAmount.quantity;
            }

            if (shift_5) {
              let verifyAmount = isValidAmount(
                shift_5_quantity,
                unit_of_measurement_value
              );

              if (verifyAmount.error) {
                this.errors.push({
                  id: this.errors.length,
                  message: verifyAmount.message,
                });
              }

              shift_5_quantity = verifyAmount.quantity;
            }

            if (shift_6) {
              let verifyAmount = isValidAmount(
                shift_6_quantity,
                unit_of_measurement_value
              );

              if (verifyAmount.error) {
                this.errors.push({
                  id: this.errors.length,
                  message: verifyAmount.message,
                });
              }

              shift_6_quantity = verifyAmount.quantity;
            }

            if (shift_7) {
              let verifyAmount = isValidAmount(
                shift_7_quantity,
                unit_of_measurement_value
              );

              if (verifyAmount.error) {
                this.errors.push({
                  id: this.errors.length,
                  message: verifyAmount.message,
                });
              }

              shift_7_quantity = verifyAmount.quantity;
            }

            if (shift_8) {
              let verifyAmount = isValidAmount(
                shift_8_quantity,
                unit_of_measurement_value
              );

              if (verifyAmount.error) {
                this.errors.push({
                  id: this.errors.length,
                  message: verifyAmount.message,
                });
              }

              shift_8_quantity = verifyAmount.quantity;
            }
          }

          if (type_medicine_amount_of_times_id == "DAY") {
            if (!String(every).trim()) {
              this.errors.push({
                id: this.errors.length,
                message: `Informe a cada ${medicine_frequency_abbreviation}`,
              });
            }

            let verifyAmount = isValidAmount(
              quantity,
              unit_of_measurement_value
            );

            if (verifyAmount.error) {
              this.errors.push({
                id: this.errors.length,
                message: verifyAmount.message,
              });
            }

            quantity = verifyAmount.quantity;
          }
        }

        if (frequency == EVENTUAL) {
          let verifyAmount = isValidAmount(quantity, unit_of_measurement_value);

          if (verifyAmount.error) {
            this.errors.push({
              id: this.errors.length,
              message: verifyAmount.message,
            });
          }

          quantity = verifyAmount.quantity;
        }

        if (this.errors.length > 0) {
          return;
        }

        if (frequency == EVENTUAL) {
          this.show_instruction = true;
        } else {
          this.show_instruction = false;
        }

        if (frequency == DIARIO) {
          this.show_during_a_period = true;
        } else {
          this.show_during_a_period = false;
        }

        if (group_prescription_medicine.type == "NORMAL") {
          this.step = step + 1;
        } else {
          if (frequency == SEMANAL) {
            this.step = step + 1;
          } else {
            this.step = 2.5;
          }
        }
        // this.step = step + 1;
      }

      if (step == 2.5) {
        this.step = 3;
      }

      if (step == 3) {
        let {
          frequency,
          duration,
          instruction,
          start_date,
          end_date,
          duration_time,
          init,
        } = this;

        // let DIARIO = "DIARIO";
        // let SEMANAL = "SEMANAL";
        // let MENSAL = "MENSAL";
        // let ANUAL = "ANUAL";
        let EVENTUAL = "EVENTUAL";

        const ATE_A_DATA = "ATE_A_DATA";
        const DURANTE_UM_PERIODO = "DURANTE_UM_PERIODO";

        if (duration == ATE_A_DATA) {
          if (frequency != EVENTUAL) {
            if (!String(start_date).trim()) {
              this.errors.push({
                id: this.errors.length,
                message: "Informe a data de início",
              });
            }
          }

          if (!String(end_date).trim()) {
            this.errors.push({
              id: this.errors.length,
              message: "Informe data de término",
            });
          }
        }

        if (duration == DURANTE_UM_PERIODO) {
          if (frequency != EVENTUAL) {
            if (!String(start_date).trim()) {
              this.errors.push({
                id: this.errors.length,
                message: "Informe a data de início",
              });
            }
          }

          if (!String(duration_time).trim()) {
            this.errors.push({
              id: this.errors.length,
              message: "Informe tempo de duração",
            });
          }
        }

        if (frequency == EVENTUAL) {
          if (!String(instruction).trim()) {
            this.errors.push({
              id: this.errors.length,
              message: "Informe instrução",
            });
          }
        }

        if (!init && duration == "CONTINUO") {
          this.errors.push({
            id: this.errors.length,
            message: "Informe a data que o medicamento irá iniciar",
          });
        }

        if (this.errors.length > 0) {
          return;
        }

        this.create();
      }
    },
    selected(medicine) {
      this.errors = [];

      if (medicine.id) {
        let {
          name,
          active_ingredient_id,
          unit_of_measurement_id,
          unit_of_measurement_name,
          unit_of_measurement_value,
          unit_of_measurement_abbreviation,
          type_of_recipe_id,
          type,
        } = medicine;

        this.medicine = medicine;
        this.name = name;
        this.active_ingredient_id = active_ingredient_id;
        this.unit_of_measurement_id = unit_of_measurement_id;
        this.unit_of_measurement_name = unit_of_measurement_name;
        this.unit_of_measurement_value = unit_of_measurement_value;
        this.type_of_recipe_id = type_of_recipe_id;
        if (
          unit_of_measurement_value == "ML" ||
          unit_of_measurement_value == "UI"
        ) {
          this.ml_or_drops = unit_of_measurement_value;
          this.ml_or_drops_morning_quantity = unit_of_measurement_value;
          this.ml_or_drops_afternoon_quantity = unit_of_measurement_value;
          this.ml_or_drops_night_quantity = unit_of_measurement_value;
          this.ml_or_drops_dawn_quantity = unit_of_measurement_value;
          this.ml_or_drops_shift_5_quantity = unit_of_measurement_value;
          this.ml_or_drops_shift_6_quantity = unit_of_measurement_value;
          this.ml_or_drops_shift_7_quantity = unit_of_measurement_value;
          this.ml_or_drops_shift_8_quantity = unit_of_measurement_value;
        } else {
          this.ml_or_drops = null;
          this.ml_or_drops_morning_quantity = null;
          this.ml_or_drops_afternoon_quantity = null;
          this.ml_or_drops_night_quantity = null;
          this.ml_or_drops_dawn_quantity = null;
          this.ml_or_drops_shift_5_quantity = null;
          this.ml_or_drops_shift_6_quantity = null;
          this.ml_or_drops_shift_7_quantity = null;
          this.ml_or_drops_shift_8_quantity = null;
        }
        this.unit_of_measurement_abbreviation =
          unit_of_measurement_abbreviation;
        this.medicine_type = type;
      } else {
        this.medicine = null;
        this.name = medicine;
        this.active_ingredient_id = "";
        this.unit_of_measurement_id = "";
        this.unit_of_measurement_name = "";
        this.unit_of_measurement_value = "";
        this.unit_of_measurement_abbreviation = "";
        this.ml_or_drops = null;
        this.ml_or_drops_morning_quantity = null;
        this.ml_or_drops_afternoon_quantity = null;
        this.ml_or_drops_night_quantity = null;
        this.ml_or_drops_dawn_quantity = null;
        this.ml_or_drops_shift_5_quantity = null;
        this.ml_or_drops_shift_6_quantity = null;
        this.ml_or_drops_shift_7_quantity = null;
        this.ml_or_drops_shift_8_quantity = null;
        this.type_of_recipe_id = null;
        this.medicine_type = null;
      }

      this.step = 1;
    },
    handleModalAddPrescription() {
      this.$bvModal.show("modalAddPrescription");
    },
    handleChangeUnitOfMeasurementId(value) {
      this.unit_of_measurement_abbreviation = "";

      if (value) {
        let { name, v, abbreviation } =
          this.$refs[`unit_of_measurement_${value}`][0].dataset;

        if (v == "ML" || v == "UI") {
          this.ml_or_drops = v;
          this.ml_or_drops_morning_quantity = v;
          this.ml_or_drops_afternoon_quantity = v;
          this.ml_or_drops_night_quantity = v;
          this.ml_or_drops_dawn_quantity = v;
          this.ml_or_drops_shift_5_quantity = v;
          this.ml_or_drops_shift_6_quantity = v;
          this.ml_or_drops_shift_7_quantity = v;
          this.ml_or_drops_shift_8_quantity = v;
        } else {
          this.ml_or_drops = null;
          this.ml_or_drops_morning_quantity = null;
          this.ml_or_drops_afternoon_quantity = null;
          this.ml_or_drops_night_quantity = null;
          this.ml_or_drops_dawn_quantity = null;
          this.ml_or_drops_shift_5_quantity = null;
          this.ml_or_drops_shift_6_quantity = null;
          this.ml_or_drops_shift_7_quantity = null;
          this.ml_or_drops_shift_8_quantity = null;
        }

        this.unit_of_measurement_name = name;
        this.unit_of_measurement_value = v;
        this.unit_of_measurement_abbreviation = abbreviation;
      }
    },
    handleChangeMedicineAmountOfTimesId(value) {
      this.show_quantity = true;
      this.show_shifts = false;
      this.medicine_amount_of_times_abbreviation = "";

      const SHIFTS = "SHIFTS";

      if (value) {
        let { type } =
          this.$refs[`medicine_amount_of_times_${value}`][0].dataset;

        this.type_medicine_amount_of_times_id = type;

        if (type == SHIFTS) {
          this.show_shifts = true;
          this.show_quantity = false;
        }
      }
    },
    handleChangeFrequency(value) {
      const { medicineAmountOfTimes } = this;

      this.show_all_frequency = true;
      this.show_weekly = false;
      this.show_duration_time = false;
      this.show_quantity = true;
      this.show_quantity_of_times_a_day = false;
      this.duration = "CONTINUO";
      this.amountOfTimes = medicineAmountOfTimes;

      this.DOM = false;
      this.SEG = false;
      this.TER = false;
      this.QUA = false;
      this.QUI = false;
      this.SEX = false;
      this.SAB = false;

      let medicine_frequency_abbreviation = {
        DIARIO: "DIA",
        SEMANAL: "SEMANA",
        MENSAL: "MÊS",
        ANUAL: "ANO",
      };

      //   const DIARIO = "DIARIO";
      const SEMANAL = "SEMANAL";
      //   const MENSAL = "MENSAL";
      //   const ANUAL = "ANUAL";
      const EVENTUAL = "EVENTUAL";

      if (value == EVENTUAL) {
        this.show_quantity_of_times_a_day = true;
        this.show_all_frequency = false;
        this.medicine_amount_of_times_id = 1;
        this.type_medicine_amount_of_times_id = "DAY";
        this.show_shifts = false;

        let amountOfTimes = [];

        for (let item of medicineAmountOfTimes) {
          if (item.type == "DAY") {
            amountOfTimes.push(item);
          }
        }

        this.amountOfTimes = amountOfTimes;
      }

      if (value == SEMANAL) {
        this.show_weekly = true;
      }

      this.medicine_frequency_abbreviation =
        medicine_frequency_abbreviation[value];
    },
    handleChangeDuration(value) {
      const CONTINUO = "CONTINUO";
      const ATE_A_DATA = "ATE_A_DATA";
      const DURANTE_UM_PERIODO = "DURANTE_UM_PERIODO";

      if (value == CONTINUO) {
        this.show_start_date = false;
      } else {
        this.show_start_date = true;
      }

      if (value == ATE_A_DATA) {
        this.show_end_date = true;
      } else {
        this.show_end_date = false;
      }

      if (value == DURANTE_UM_PERIODO) {
        this.show_duration_time = true;
      } else {
        this.show_duration_time = false;
      }
    },
    async retrieve() {
      const { user } = userData();

      this.rest_home_id = user.rest_home_id;
      this.user_id = user.id;

      const { group_prescription_medicine } = this;

      if (group_prescription_medicine.type == "LONGO_PRAZO") {
        this.frequency = "MENSAL";
        this.handleChangeFrequency("MENSAL");
      }

      if (this.errors.length == 0) await this.getUnitOfMeasurements();
      if (this.errors.length == 0) await this.getActiveIngredient();
      if (this.errors.length == 0) await this.getRouteOfAdministration();
      if (this.errors.length == 0) await this.getMedicineAmountOfTimes();
      if (this.errors.length == 0) await this.getTypesOfRecipe();
    },
    async getTypesOfRecipe() {
      try {
        const response = await api.get("/rest-home/type-of-recipe/all");

        const { error, errors, types } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.typesOfRecipe = types;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getUnitOfMeasurements() {
      try {
        const response = await api.get("/rest-home/unit-of-measurement/all");

        const { error, errors, unit_of_measurement } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.unitOfMeasurements = unit_of_measurement;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getActiveIngredient() {
      try {
        const response = await api.get("/rest-home/active-ingredients");

        const { error, errors, active_ingredient } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.active_ingredient = active_ingredient;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getRouteOfAdministration() {
      try {
        const response = await api.get("/admin/care/routes-of-administration");

        const { error, errors, routes_of_administration } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.routeOfAdministration = routes_of_administration;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getMedicineAmountOfTimes() {
      try {
        const response = await api.get("/admin/medicine-amount-of-times");

        const { error, errors, medicine_amount_of_times } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          if (medicine_amount_of_times.length > 1) {
            this.medicine_amount_of_times_id = medicine_amount_of_times[1].id;
          }

          this.medicineAmountOfTimes = medicine_amount_of_times;
          this.amountOfTimes = medicine_amount_of_times;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async create() {
      try {
        this.loading = true;

        let {
          group_prescription_medicine,
          rest_home_id,
          user_id,
          medicine, //MEDICAMENTO
          medicine_type, //TIPO MEDICAMENTO
          name, //NOME COMERCIAL
          active_ingredient_id, //PRINCÍPIO ATIVO
          unit_of_measurement_id, //UNIDADE DE MEDIDA
          unit_of_measurement_value, //VALOR UNIDADE DE MEDIDA
          route_of_administration_id, //VIA DE ADMINISTRAÇÃO
          type_of_recipe_id, //TIPO DE RECEITA
          frequency, //FREQUÊNCIA
          medicine_amount_of_times_id, //QUANTIDADE DIÁRIA
          type_medicine_amount_of_times_id, //TIPO QUANTIDADE DIÁRIA
          every, //A CADA,
          DOM,
          SEG,
          TER,
          QUA,
          QUI,
          SEX,
          SAB,
          morning, //MANHÃ
          morning_quantity,
          afternoon, //TARDE
          afternoon_quantity,
          night, //NOITE
          night_quantity,
          dawn, //MADRUGADA
          dawn_quantity,
          shift_5, //5
          shift_5_quantity,
          shift_6, //6
          shift_6_quantity,
          shift_7, //7
          shift_7_quantity,
          shift_8, //8
          shift_8_quantity,
          quantity, //QUANTIDADE
          start_date, //DATA DE INÍCIO
          duration, //DURAÇÃO
          duration_time, //TEMPO DE DURAÇÃO
          end_date, //DATA DE TÉRMINO
          instruction, //INSTRUÇÃO
          ml_or_drops,
          ml_or_drops_morning_quantity,
          ml_or_drops_afternoon_quantity,
          ml_or_drops_night_quantity,
          ml_or_drops_dawn_quantity,
          ml_or_drops_shift_5_quantity,
          ml_or_drops_shift_6_quantity,
          ml_or_drops_shift_7_quantity,
          ml_or_drops_shift_8_quantity,
          repeat_after_type,
          repeat_dosage,
          repeat_type,
          repeat_after,
          how_many_times,
          init,
        } = this;

        let params = {
          group_prescription_medicine_id: group_prescription_medicine.id,
          rest_home_id,
          user_id,
          resident_id: group_prescription_medicine.resident_id,
          medicine,
          medicine_type,
          name,
          active_ingredient_id,
          unit_of_measurement_id,
          unit_of_measurement_value,
          route_of_administration_id,
          type_of_recipe_id,
          frequency,
          medicine_amount_of_times_id,
          type_medicine_amount_of_times_id,
          every,
          DOM,
          SEG,
          TER,
          QUA,
          QUI,
          SEX,
          SAB,
          morning,
          morning_quantity,
          afternoon,
          afternoon_quantity,
          night,
          night_quantity,
          dawn,
          dawn_quantity,
          shift_5,
          shift_5_quantity,
          shift_6,
          shift_6_quantity,
          shift_7,
          shift_7_quantity,
          shift_8,
          shift_8_quantity,
          quantity,
          start_date,
          duration,
          duration_time,
          end_date,
          instruction,
          ml_or_drops,
          ml_or_drops_morning_quantity,
          ml_or_drops_afternoon_quantity,
          ml_or_drops_night_quantity,
          ml_or_drops_dawn_quantity,
          ml_or_drops_shift_5_quantity,
          ml_or_drops_shift_6_quantity,
          ml_or_drops_shift_7_quantity,
          ml_or_drops_shift_8_quantity,
          repeat_after_type,
          repeat_dosage,
          repeat_type,
          repeat_after,
          how_many_times,
          init,
        };

        const response = await api.post(
          "/rest-home/prescription-medicine",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$emit("create", "paginate");
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
